import { render, staticRenderFns } from "./ShotValRewards.vue?vue&type=template&id=5208f927&"
import script from "./ShotValRewards.vue?vue&type=script&lang=js&"
export * from "./ShotValRewards.vue?vue&type=script&lang=js&"
import style0 from "./ShotValRewards.vue?vue&type=style&index=0&id=5208f927&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports